import { LoadMoreGridSettings } from '../../models';

export const getLoadMoreTotalPageCount = (gridSettings: LoadMoreGridSettings): number => {
  return gridSettings.PageIndex + 1 + (gridSettings.LoadMore ? 1 : 0);
};

export const getLoadMoreTotalItemCount = (gridSettings: LoadMoreGridSettings): number => {
  return gridSettings.PageSize * (gridSettings.PageIndex + 1);
};
